import { render, staticRenderFns } from "./SmsTemplates.vue?vue&type=template&id=6c061ec1"
import script from "./SmsTemplates.vue?vue&type=script&lang=js"
export * from "./SmsTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports